import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@shared/ui/card";
import { VisArea, VisAxis, VisCrosshair, VisLine, VisTooltip, VisXYContainer } from "@unovis/react";
import { FormattedMessage } from "react-intl";
import { CurveType } from "@unovis/ts";

type DataRecord = {
	day: string;
	requests: number;
	errors: number;
};

const data: DataRecord[] = [
	{ day: "Mon", requests: 142000, errors: 620 },
	{ day: "Tue", requests: 168000, errors: 540 },
	{ day: "Wed", requests: 158000, errors: 710 },
	{ day: "Thu", requests: 192000, errors: 480 },
	{ day: "Fri", requests: 221000, errors: 510 },
	{ day: "Sat", requests: 184000, errors: 390 },
	{ day: "Sun", requests: 205000, errors: 460 },
];

const x = (_: DataRecord, i: number) => i;
const y = (d: DataRecord) => d.requests;

export function TrafficChart() {
	return (
		<Card className="lg:col-span-2">
			<CardHeader>
				<CardTitle>
					<FormattedMessage id="dashboard.trafficChart.title" defaultMessage="API traffic" />
				</CardTitle>
				<CardDescription>
					<FormattedMessage
						id="dashboard.trafficChart.description"
						defaultMessage="Requests over the last 7 days"
					/>
				</CardDescription>
			</CardHeader>
			<CardContent>
				<VisXYContainer data={data} height={280}>
					<VisArea
						x={x}
						y={y}
						curveType={CurveType.MonotoneX}
						color="var(--primary)"
						opacity={0.2}
					/>
					<VisLine x={x} y={y} curveType={CurveType.MonotoneX} color="var(--primary)" />
					<VisAxis
						type="x"
						tickFormat={(_: number | Date, i: number) => data[i]?.day ?? ""}
						gridLine={false}
						tickLine={false}
					/>
					<VisAxis
						type="y"
						tickFormat={(v: number | Date) => `${(Number(v) / 1000).toFixed(0)}k`}
						gridLine={true}
						tickLine={false}
					/>
					<VisCrosshair
						template={(d: DataRecord) =>
							`<div class="text-xs p-1"><b>${d.day}</b><br/>Requests: ${d.requests.toLocaleString()}</div>`
						}
					/>
					<VisTooltip />
				</VisXYContainer>
			</CardContent>
		</Card>
	);
}
